/**
 * 创建人：袁俊双
 * 时间：2020-9-22
 * 描述：将空值转化为固定的默认值（一般用于管道后再次管道，空值的时候将空值翻译为'其他'之类的）
 * 更新记录: 
 */
import { Pipe, PipeTransform } from '@angular/core';

/**
 * 将空值转化为默认值
 * @example <span>{{data.module | dictionary | defaultValue:'其他'}}</span>
 */

@Pipe({
  name: 'defaultValue'
})
export class DefaultValuePipe implements PipeTransform {

  /**
   * 管道的初始化方法
   * @param value 传入的数据 number 或者 string
   */
  transform(value: any , defaultValue: string ): any {
    if(value){
      //表面该HTML是可信赖的
      return value
    } else {
      return defaultValue
    }
  }

}
